import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import {
  PnsMacMini,
  PaginatedPnsMacMiniResponse,
  PnsMacMiniStatus,
} from 'interfaces/pns-mac-mini'

interface ReceivedMacMinisParams {
  terminalId?: string
  page?: number
  limit?: number
  name?: string
}

const fetchReceivedMacMinis = async (
  params: ReceivedMacMinisParams
): Promise<PaginatedPnsMacMiniResponse> => {
  const searchParams = new URLSearchParams()

  if (params.terminalId) searchParams.append('terminalId', params.terminalId)
  if (params.page)
    searchParams.append(
      'offset',
      ((params.page - 1) * (params.limit || 20)).toString()
    )
  if (params.limit) searchParams.append('limit', params.limit.toString())
  if (params.name) searchParams.append('nameSearch', params.name)

  // Only fetch RECEIVED status devices
  searchParams.append('status', PnsMacMiniStatus.RECEIVED)

  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/mac_minis?${searchParams.toString()}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  return response.json()
}

const useReceivedMacMinis = (params: ReceivedMacMinisParams = {}) => {
  return useQuery(
    ['received-mac-minis', params],
    () => fetchReceivedMacMinis(params),
    {
      enabled: !!params.terminalId,
      staleTime: 30000,
      retry: 2,
    }
  )
}

// Hook to get count of received Mac Minis for a terminal
const useReceivedMacMinisCount = (terminalId?: string) => {
  return useQuery(
    ['received-mac-minis-count', terminalId],
    () => fetchReceivedMacMinis({ terminalId, limit: 1 }),
    {
      enabled: !!terminalId,
      staleTime: 30000,
      retry: 2,
      select: (data) => data.pagination.total,
    }
  )
}

export default useReceivedMacMinis
export { useReceivedMacMinisCount }
